import { apiRequest } from '../../api/http';
import { readTokens } from '../../auth/tokens';
const inFlight = new Set<string>();
export async function triggerAdminVisitDiscovery(adminId: string) {
  if (!adminId || !readTokens()?.access_token || document.visibilityState !== 'visible' || inFlight.has(adminId)) return;
  const parts = new Intl.DateTimeFormat('en-GB', {timeZone: 'Asia/Bangkok', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'}).formatToParts(new Date());
  const part = (key: string) => parts.find(item => item.type === key)?.value || '';
  const hour = Number(part('hour'));
  const period = hour >= 11 && hour < 13 ? 'pre-lunch' : hour >= 14 && hour < 16 ? 'afternoon-drink' : hour >= 17 && hour < 19 ? 'pre-dinner' : '';
  if (!period) return;
  const key = `beaw.discovery.visit:${adminId}:${part('year')}-${part('month')}-${part('day')}:${period}`;
  try {
    if (Date.now() - Number(localStorage.getItem(key) || 0) < 5 * 60_000) return;
    localStorage.setItem(key, String(Date.now()));
  } catch { /* Server-side claims still prevent duplicate batches. */ }
  inFlight.add(adminId);
  try { await apiRequest('/admin/notifications/inactivity-reminders/trigger', {method: 'POST'}); }
  catch { /* Opportunistic work must not interrupt admin navigation. */ }
  finally { inFlight.delete(adminId); }
}
